import styled from "styled-components";

import { SPACING } from "../../../../utils/constants";

export const PredictionRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${SPACING.sm}px;
  margin-top: ${SPACING.sm}px;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
`;

export const PredictionDate = styled.span`
  font-size: var(--text-base);
  font-weight: 700;
  color: var(--color-text-default);
`;
